import { withSentryReactRouterV6Routing } from "@sentry/react";
import View from "./views/view";
import { Routes, Route, useLocation } from "react-router-dom";
import Survey from "./views/survey";
import Dashboard from "./views/dashboard";
import { Stats } from "./views/stats";
import { createContext, useState, useLayoutEffect } from "react";
import SharedResultPage from "./views/shared_result_page";
import Analytics from "./analytics";

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export const ClassContext = createContext();

export default function App() {
  const [profiles, setProfiles] = useState([]);

  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ClassContext.Provider value={{ profiles, setProfiles }}>
      <Analytics />
      <SentryRoutes>
        <Route path="/" element={<View />} />
        <Route path="/survey" element={<Survey />} />
        <Route path="/dashboard/:id" element={<Stats />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/result" element={<SharedResultPage />} />
      </SentryRoutes>
    </ClassContext.Provider>
  );
}
